module.exports = __webpack_public_path__ + "static/media/Kricketot_gaussian2.c8800f27.png";